<template>
  <hs-modal :model-value="true" :title="`${label} subscription`" size="sm" @close="close">
    <div class="space-y-4">
      <p class="text-sm">{{ subscription.store_name || `Store #${subscription.store_id}` }} · {{ subscription.plan?.display_name }}</p>
      <p class="text-sm text-gray-500">{{ explanation }}</p>
      <label class="block text-sm font-medium">
        Reason {{ action === 'ACTIVE' ? '(optional)' : '(required)' }}
        <textarea v-model="reason" :disabled="saving" :required="action !== 'ACTIVE'" maxlength="2000" rows="4" class="status-reason" />
      </label>
      <p class="text-xs text-gray-500">{{ reason.length }}/2000</p>
      <hs-alert v-if="error" tone="danger" :message="error" />
    </div>
    <template #footer>
      <hs-button variant="secondary" :disabled="saving" @click="close">Back</hs-button>
      <hs-button :variant="action === 'CANCELLED' ? 'danger' : 'primary'" :loading="saving" @click="save">{{ label }} subscription</hs-button>
    </template>
  </hs-modal>
</template>

<script>
import { HsModal, HsButton, HsAlert } from "@/components/ui";
import http from "@/helper/http";

export default {
  name: "SubscriptionStatusModal",
  components: { HsModal, HsButton, HsAlert },
  props: {
    subscription: { type: Object, required: true },
    action: { type: String, required: true, validator: (value) => ["ACTIVE", "SUSPENDED", "CANCELLED"].includes(value) },
  },
  emits: ["close", "saved"],
  data: () => ({ reason: "", saving: false, error: "" }),
  computed: {
    label() { return { ACTIVE: "Resume", SUSPENDED: "Suspend", CANCELLED: "Cancel" }[this.action]; },
    explanation() {
      return {
        ACTIVE: "Restore this subscription for its remaining period. The original start and expiry dates stay the same.",
        SUSPENDED: "Pause access from this subscription. Suspension does not extend its expiry date.",
        CANCELLED: "Permanently stop this subscription. Its history is preserved and it cannot be resumed.",
      }[this.action];
    },
  },
  methods: {
    close() { if (!this.saving) this.$emit("close"); },
    async save() {
      if (this.saving) return;
      this.error = "";
      const reason = this.reason.trim();
      if ((this.action !== "ACTIVE" && !reason) || reason.length > 2000) {
        this.error = "Enter a reason of 1–2000 characters.";
        return;
      }
      this.saving = true;
      try {
        const payload = { status: this.action };
        if (reason) payload.reason = reason;
        const { data } = await http.patch(`/v1/admin/subscriptions/stores/${this.subscription.id}`, payload);
        this.$emit("saved", data);
      } catch (error) {
        this.error = error?.response?.data?.error?.message || "Unable to update subscription status.";
      } finally { this.saving = false; }
    },
  },
};
</script>

<style scoped>
.status-reason {
  display: block; width: 100%; margin-top: 0.5rem; padding: 0.75rem;
  border: 1px solid var(--hs-border, #e2e8f0); border-radius: 0.5rem;
  background: var(--hs-surface, #fff); color: var(--hs-text, #0f172a);
  font: inherit; resize: vertical;
}
</style>
